import { useCallback, useEffect, useRef, useState } from 'react'
import {
  bedAssignmentList,
  emptyString,
  noData,
  pageSizeOptions,
} from '../../Radiology/Constants/constants'
import {
  dischargePatient,
  dropDownStatusIpd,
  ipdPatients,
  selectDischargeDate,
} from '../constants'
import { allocation } from '../modals'
import { useBeds } from './useBeds'
import { mappedPatientsIPD } from '../../lms/utils'
import { getReasonStatus } from '../IpdUtils'
import '../bms.scss'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useTheme,
} from '@mui/material'
import uploadIcon from '../../../assets/images/download_uplaod.webp'
import patientDashboardIcon from './../../../assets/images/patientDashboardIcon.webp'
import { setQueryParam } from '../IpdVisit/IpdVisitSlice'
import { useAppDispatch } from '../../../app/hooks'
import SelectableSearch from '../../../components/SelectableSearch'
import { BED_IPD_DASHBOARD_URL } from '../endpoints/EndPoints'
import ProvenanceView from '../../../components/ProvenanceView'
import { create, update } from '../../lms/constants'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import {
  archiveBedAssignmentRecord,
  deleteBedAssignmentRecord,
  getAllBedAndPatientsByStatusAndLocation,
} from '../../../services/IPDService'
import AddDischargeDetails from './AddDischargeDetails'
import CloseIcon from '@mui/icons-material/Close'
import KeycloakService from '../../../utils/keycloakService'
import { IPD_DISCHARGE_ADMIN, PATIENTS_WRITE } from '../../../utils/roles'
import AdminDischargeDateDialog from './AdminDischargeDateDialog'
import { ColDef } from 'ag-grid-community'
import MedAgDataGrid from '../../../components/MedAgDataGrid'
import { radiologyColor } from '../../Radiology/Utils/RadiologyColors'
import CustomHeader from '../../Radiology/components/RadiologyModel/CustomHeader'
import { selectableSearchOptions } from '../../membership/models'
import EditNoteIcon from '@mui/icons-material/EditNote'
import { toast } from 'react-toastify'
import DropdownMenu from '../../../components/DropdownMenu/DropdownMenu'
import { exportExcel } from '../../../utils/hooks/Utils'
import { dropDownMenuKeys, noDataMessage } from '../../../components/constants'
import IpdUploadDocs from '../IpdVisit/IpdUploadDocs'
const styles = () => ({
  tablePagination: {
    marginRight: '6rem',
  },
  titlePosition: {
    position: 'absolute',
    top: 8,
    right: 12,
  },
  dischargeDateContent: {
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underLine',
  },
  withoutDischargeDateContent: {
    width: '21px',
  },
  dialogContainer: {
    '& .MuiDialog-paper': {
      width: '73% !important',
    },
  },
  centerHeader: {
    color: radiologyColor?.white,
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  MedAgDataGridExportIcon: {
    background: '#4682b4',
    color: '#ffffff',
    borderRadius: 5,
  },
  disabledBtn: {
    background: 'grey',
    cursor: 'none',
  },
  iconButton: {
    padding: 'unset',
  },
  patientDashboardIcon: {
    width: '18px !important',
  },
  calendarMonthIcon: {
    color: '#625e5e !important',
    width: '20px',
    height: '20px',
  },
})

const BedAssignmentList = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const dispatch = useAppDispatch()
  const locations = useBeds()
  const navigate = useNavigate()
  const [bedPatientList, setBedpatient] = useState<ipdPatients[]>([])
  const [locationName, setLocationName] = useState<string>('')
  const [status, setStatus] = useState<string>('ASSIGNED')
  const [updatedCount, setUpdatedCount] = useState(0)

  const [isOpenDocsPage, setIsOpenDocsPage] = useState(false)
  const [selectedPatientId, setSelectedPatientId] = useState<string>('')
  const [selectedMuhId, setSelectedMuhId] = useState<string>('')
  const patientTableContainerRef = useRef<HTMLDivElement | null>(null)

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100)
  const [totalElements, setTotalElements] = useState(0)
  const [paginationLoading, setPaginationLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [dischargeOperation, setDischargeOPeration] = useState(false)
  const [dischargeDetails, setDischargeDetails] = useState<ipdPatients | null>(
    null
  )
  const [filterStatus, setFilterStatus] = useState(dropDownMenuKeys?.active)
  const [dischargeDateAdmin, setDischargeDateAdmin] = useState(false)
  const [dischargeAdmin, setDischargeAdmin] = useState<ipdPatients | null>(null)
  const [apiLoading, setApiLoading] = useState(false)
  const [selectedBedId, setSelectedBedId] = useState<string | null>(null)
  const dateObject = (dateString: string) => {
    const dateObject = new Date(dateString)
    const formattedDate = dateObject.toISOString().split('T')[0]
    return formattedDate
  }
  const differenceInDays = (d1: string, d2: any) => {
    const presentDate = new Date()
    const admittedDate = new Date(d1)
    const dischargedDate = new Date(d2)
    if (d2) {
      const DifferenceInTime = dischargedDate.getTime() - admittedDate.getTime()

      const DifferenceInDays = Math.round(DifferenceInTime / (1000 * 3600 * 24))
      return DifferenceInDays
    } else {
      const DifferenceInTime = presentDate.getTime() - admittedDate.getTime()

      const DifferenceInDays = Math.round(DifferenceInTime / (1000 * 3600 * 24))
      return DifferenceInDays
    }
  }

  const handleDocClick = (patientId: string, muhid: string) => {
    setIsOpenDocsPage(true)
    setSelectedPatientId(patientId)
    setSelectedMuhId(muhid)
  }
  const handleCloseDialog = () => {
    setIsOpenDocsPage(false)
  }

  const getTableData = useCallback(async () => {
    const active = filterStatus === dropDownMenuKeys?.active ? true : false
    setPaginationLoading(true)
    const response: {
      data: any
      success: boolean
      message: string
    } = await getAllBedAndPatientsByStatusAndLocation(
      status,
      locationName,
      page,
      rowsPerPage,
      searchTerm,
      active
    )

    if (response?.success) {
      const mapped = await mappedPatientsIPD(response?.data?.data)
      setBedpatient(mapped)
      setPage(response?.data?.page)
      setRowsPerPage(response?.data?.size)
      setTotalElements(response?.data?.totalElements)
      setPaginationLoading(false)
    } else {
      setBedpatient([])
      setPage(0)
      setRowsPerPage(50)
      setTotalElements(0)
      setPaginationLoading(false)
    }
  }, [
    status,
    locationName,
    page,
    rowsPerPage,
    searchTerm,
    setBedpatient,
    setPage,
    setRowsPerPage,
    setTotalElements,
    filterStatus,
  ])

  const handlePatientDashboard = (
    e: string,
    id: string,
    bedId: number,
    bedStatus: string
  ) => {
    dispatch(setQueryParam({ patientId: e, id: id }))
    navigate(
      `${BED_IPD_DASHBOARD_URL}?id=${e}&bedId=${bedId}&bedStatus=${bedStatus}`
    )
  }
  const handleSearch = (query: string, param: string) => {
    setSearchTerm(param)
  }

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStatus(e.target.value)
    setPage(0)
    setRowsPerPage(100)
  }

  const handleLocationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLocationName(e.target.value)
    setPage(0)
    setRowsPerPage(100)
  }

  useEffect(() => {
    getTableData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    rowsPerPage,
    status,
    locationName,
    searchTerm,
    updatedCount,
    filterStatus,
  ])

  useEffect(() => {
    const resizeHandler = () => {
      const container = patientTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 70}px`
      }
    }
    window.addEventListener('resize', resizeHandler)
    resizeHandler()
    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])

  const dischargeIcon = (id: ipdPatients) => {
    setDischargeOPeration(true)
    setDischargeDetails(id)
  }
  const handleDischargeClose = () => {
    setDischargeOPeration(false)
    setDischargeDetails(null)
  }
  const dischargeDate = (d: ipdPatients) => {
    setDischargeDateAdmin(true)
    setDischargeAdmin(d)
  }
  const handleDischargeAdminClose = () => {
    setDischargeDateAdmin(false)
    setDischargeAdmin(null)
  }
  const dischargeDateColumn = (params: any) => {
    const d = params?.data
    return params?.data?.dateOfDischarge ? (
      <>
        {KeycloakService?.hasRole([IPD_DISCHARGE_ADMIN]) ? (
          <span
            className={classes?.dischargeDateContent}
            onClick={() => dischargeDate(params?.data)}
          >
            {dateObject(d?.dateOfDischarge)}
          </span>
        ) : (
          dateObject(d?.dateOfDischarge)
        )}
      </>
    ) : KeycloakService?.hasRole([IPD_DISCHARGE_ADMIN]) ? (
      <IconButton
        data-testid='discharge-edit-icon'
        onClick={() => dischargeIcon(d)}
        disabled={!KeycloakService.hasRole([PATIENTS_WRITE])}
      >
        <EditNoteIcon
          data-testid='discharge-edit-icon'
          fontSize='small'
          className={classes?.calendarMonthIcon}
        />
      </IconButton>
    ) : (
      noData
    )
  }
  const handlePatientDocuments = (params: any) => {
    const d = params?.data
    return (
      <div
        onClick={() =>
          handleDocClick(d.patient_registered_id, d.patientId ?? '')
        }
        className='uploadbtn text-center'
      >
        <img title='upload document' src={uploadIcon} alt='upload button' />
      </div>
    )
  }
  const handleView = (params: any) => {
    const d = params?.data
    return (
      <div className='uploadbtn'>
        <img
          title='patient Dashboard'
          src={patientDashboardIcon}
          onClick={() =>
            handlePatientDashboard(
              d?.patientId,
              d?.patient_registered_id,
              d?.bedId,
              d?.bedStatus
            )
          }
          alt='patient Dashboard'
          className={classes?.patientDashboardIcon}
        />
      </div>
    )
  }
  const deleteVisit = async () => {
    setApiLoading(true)
    const response = await deleteBedAssignmentRecord(selectedBedId)
    if (response?.success) {
      setApiLoading(false)
      toast?.success(response?.message)
      setSelectedBedId(null)
      setUpdatedCount((prev) => prev + 1)
    } else {
      setApiLoading(false)
      toast?.error(response?.message)
      setSelectedBedId(null)
      setUpdatedCount((prev) => prev + 1)
    }
  }
  const archiveVisit = async () => {
    setApiLoading(true)
    const response = await archiveBedAssignmentRecord(
      selectedBedId,
      filterStatus
    )
    if (response?.success) {
      setApiLoading(false)
      toast.success(response?.message)
      setSelectedBedId(null)
      setUpdatedCount((prev) => prev + 1)
    } else {
      setApiLoading(false)
      toast.error(response?.message)
      setSelectedBedId(null)
      setUpdatedCount((prev) => prev + 1)
    }
  }
  const handleExport = () => {
    if (bedPatientList?.length > 0) {
      exportExcel(bedPatientList)
    } else {
      toast.error(noDataMessage)
    }
  }
  const handleSelect = (e: any) => {
    const key = e?.[0]
    switch (key) {
      case dropDownMenuKeys?.delete:
        deleteVisit()
        break
      case dropDownMenuKeys?.archive:
        archiveVisit()
        break
      case dropDownMenuKeys?.export:
        handleExport()
        break
      case dropDownMenuKeys?.active:
        setFilterStatus(dropDownMenuKeys?.active)
        break
      case dropDownMenuKeys?.inActive:
        setFilterStatus(dropDownMenuKeys?.inActive)
        break
      default:
        break
    }
  }
  const columnDefs: ColDef[] = [
    {
      headerName: '',
      field: 'checkbox',
      sortable: false,
      filter: false,
      minWidth: 50,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { textAlign: 'center' },
      checkboxSelection: false, // AG Grid built-in selection is off
      cellRenderer: (params: any) => {
        const d = params?.data
        return (
          <input
            type='checkbox'
            className='checkbox-input'
            checked={selectedBedId === d?.id}
            disabled={d?.bedStatus !== allocation.dischargedText}
            onChange={() => {
              setSelectedBedId(selectedBedId === d?.id ? null : d?.id)
            }}
          />
        )
      },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'SL No.',
      field: 'id',
      minWidth: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        page * rowsPerPage + (params?.node?.rowIndex + 1),
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'IP Number',
      field: 'ipNumber',
      minWidth: 140,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => params?.data?.ipNumber ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'UHID',
      field: 'uhid',
      minWidth: 120,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => params?.data?.patientId ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      headerComponent: CustomHeader,
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Name',
      field: 'name',
      minWidth: 300,
      sortable: true,
      filter: true,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => params?.data?.patientName ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
      },
      flex: 1,
      wrapText: true,
      headerComponent: CustomHeader,
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Mobile',
      field: 'mobile',
      minWidth: 140,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        params?.data?.patientMobile ?? allocation.hyphen,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Gender',
      field: 'gender',
      minWidth: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        params?.data?.patientGender === 'M'
          ? 'Male'
          : params?.data?.patientGender === 'F'
          ? 'Female'
          : 'Others',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Age',
      field: 'age',
      minWidth: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        params?.data?.patientAge ?? allocation.hyphen,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'BedNo',
      field: 'bedNo',
      minWidth: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => params?.data?.bedNumber ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Operating Unit',
      field: 'location',
      minWidth: 150,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => params?.data?.location ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Adm.status',
      field: 'status',
      minWidth: 120,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        params?.data?.bedStatus === allocation?.assigned
          ? allocation?.admittedList
          : allocation?.dischargedList ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Admission Dt.',
      field: 'date',
      minWidth: 130,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        dateObject(params?.data?.dateStarted) ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Discharge Dt.',
      field: 'id',
      minWidth: 140,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: dischargeDateColumn,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },

    {
      headerName: 'Reason',
      field: 'reason',
      minWidth: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        params?.data?.additionalInfo
          ? getReasonStatus(params?.data?.additionalInfo)
          : noData,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Days Of Adm',
      field: 'days',
      minWidth: 130,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        differenceInDays(
          params?.data?.dateStarted,
          params?.data?.dateOfDischarge
        ) ?? '-',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Patient Docs',
      field: 'patientDocs',
      minWidth: 120,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: handlePatientDocuments,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },

    {
      headerName: 'View',
      field: 'view',
      minWidth: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: handleView,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Created By',
      field: 'createdBy',
      minWidth: 130,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => (
        <ProvenanceView
          mode={create}
          date={params?.data?.dateCreated ?? '-'}
          name={params?.data?.createdBy ?? '-'}
        />
      ),
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
    },
    {
      headerName: 'Updated By',
      field: 'id',
      width: 130,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => (
        <ProvenanceView
          mode={update}
          date={params?.data?.dateChanged ?? ''}
          name={params?.data?.updatedBy ?? ''}
        />
      ),
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.5,
      },
    },
  ]

  return (
    <>
      <Dialog
        open={dischargeOperation}
        onClose={handleDischargeClose}
        className={classes?.dialogContainer}
      >
        <DialogTitle>
          {dischargePatient}
          <IconButton
            edge='end'
            color='inherit'
            onClick={handleDischargeClose}
            aria-label='close'
            className={classes?.titlePosition}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <AddDischargeDetails
            onConfirm={handleDischargeClose}
            onClose={() => setDischargeOPeration(false)}
            dischargeDetails={dischargeDetails}
            setUpdatedCount={setUpdatedCount}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={dischargeDateAdmin}
        onClose={handleDischargeAdminClose}
        className={classes?.dialogContainer}
      >
        <DialogTitle>
          {selectDischargeDate}
          <IconButton
            edge='end'
            color='inherit'
            onClick={handleDischargeAdminClose}
            aria-label='close'
            className={classes?.titlePosition}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <AdminDischargeDateDialog
            onConfirm={handleDischargeAdminClose}
            onClose={() => setDischargeDateAdmin(false)}
            dischargeAdmin={dischargeAdmin}
            setUpdatedCount={setUpdatedCount}
          />
        </DialogContent>
      </Dialog>
      <Box>
        <div className='bed-assignment-text'>
          <span>{bedAssignmentList}</span>
        </div>
        <div className='lms-filters mb2 mtminus23'>
          <DropdownMenu
            onSelect={handleSelect}
            filterOptions={[
              {
                label: dropDownMenuKeys?.activeKey,
                value: dropDownMenuKeys?.active,
                active:
                  filterStatus === dropDownMenuKeys?.active ? true : false,
              },
              {
                label: dropDownMenuKeys?.inActiveKey,
                value: dropDownMenuKeys?.inActive,
                active:
                  filterStatus === dropDownMenuKeys?.inActive ? true : false,
              },
              {
                label: dropDownStatusIpd?.selectStatusKey,
                value: dropDownStatusIpd?.selectStatus,
                customRender: (
                  <select
                    className='category-filter'
                    name='status'
                    value={status}
                    disabled={filterStatus === dropDownMenuKeys?.inActive}
                    onChange={handleStatusChange}
                  >
                    <option value={allocation?.assigned}>
                      {allocation?.admittedList}
                    </option>
                    <option value={allocation?.dischargedText}>
                      {allocation?.dischargedList}
                    </option>
                    <option value={emptyString}>{allocation?.all}</option>
                  </select>
                ),
                active: true,
              },
              {
                label: dropDownStatusIpd?.selectLocationKey,
                value: dropDownStatusIpd?.selectLocation,
                customRender: (
                  <select
                    className='category-filter'
                    name='location'
                    value={locationName}
                    onChange={handleLocationChange}
                  >
                    <option value=''>{allocation?.selectLocation}</option>
                    {locations?.map((op: any, i: number) => (
                      <option key={i} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                ),
                active: true,
              },
            ]}
            actionOptions={[
              {
                label: dropDownMenuKeys?.exportKey,
                value: dropDownMenuKeys?.export,
              },
              {
                label: dropDownMenuKeys?.deleteKey,
                value: dropDownMenuKeys?.delete,
              },
              {
                label: dropDownMenuKeys?.archiveKey,
                value: dropDownMenuKeys?.archive,
              },
            ]}
            selectedId={selectedBedId ? true : false}
            filterApply={
              filterStatus === dropDownMenuKeys?.inActive ||
              status !== allocation?.assigned ||
              locationName !== ''
            }
          />
          <div>
            <select
              className='category-filter'
              name='status'
              value={status}
              disabled={filterStatus === dropDownMenuKeys?.inActive}
              onChange={handleStatusChange}
            >
              <option value={allocation?.assigned}>
                {allocation?.admittedList}
              </option>
              <option value={allocation?.dischargedText}>
                {allocation?.dischargedList}
              </option>
              <option value={emptyString}>{allocation?.all}</option>
            </select>
          </div>
          <div>
            <select
              className='category-filter'
              name='location'
              value={locationName}
              onChange={handleLocationChange}
            >
              <option value=''>{allocation?.selectLocation}</option>
              {locations?.map((op: any, i: number) => (
                <option key={i} value={op}>
                  {op}
                </option>
              ))}
            </select>
          </div>
          <SelectableSearch
            items={selectableSearchOptions}
            onSearch={handleSearch}
          />
        </div>
      </Box>
      <Box height={'95%'} width={'100%'}>
        <MedAgDataGrid
          tableHeight={'100%'}
          rowData={bedPatientList}
          columnDefs={columnDefs}
          pagination={true}
          pageSizeOptions={pageSizeOptions}
          page={page}
          setPage={setPage}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          totalRows={totalElements}
          exportIcon={false}
          searchField={false}
          headerHeight={30}
          rowHeight={40}
          localSearch={false}
          enableCellTextSelection={true}
          loading={paginationLoading || apiLoading ? true : false}
        />
      </Box>
      <Dialog open={isOpenDocsPage} onClose={handleCloseDialog} maxWidth='sm'>
        <IconButton onClick={handleCloseDialog} className='flex-end f12'>
          <CloseIcon />
        </IconButton>
        <DialogContent className='margin2 padding20'>
          {' '}
          <IpdUploadDocs
            patientId={selectedPatientId}
            muhid={selectedMuhId}
          />{' '}
        </DialogContent>
      </Dialog>
    </>
  )
}
export default BedAssignmentList
